import {FC} from "react";
import {Form, Input} from "antd";
import {VacancyFormProps} from "../../../../types";
import {VALIDATION_MESSAGES} from "../../../../../../enums/validationMessages";
import "./style.less"

const VacancyForm: FC<VacancyFormProps> = (props) => {
  const {vacancyController} = props
  return <Form className="vacancy_form" form={vacancyController.form} layout="vertical"
               onFinish={vacancyController.submitFormHandler}>
    <Form.Item name="name" label="Вакансія" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
      <Input/>
    </Form.Item>
  </Form>
}

export default VacancyForm